import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import { Link } from 'react-router-dom';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {

  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  title: {
    flexGrow: 1,
  },
  buttonName: {
    [theme.breakpoints.down('md')]: {
      fontSize: 11,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  sectionMobile: {
    display: 'flex',
  },
}));


let logo = require('../environment/client/logo/' + process.env.REACT_APP_CLIENT + '.png').default;

export default function AppHeader(props) {
  const classes = useStyles();


  return (

    <AppBar className={classes.appBar}>
      <Toolbar>
        <img alt={process.env.REACT_APP_CLIENT_NAME} src={logo} width="50px" height="50px" style={{ marginBottom: 0.5 + 'em', marginRight: 1 + 'em' }} />
        <Typography variant="title" color="inherit" component="h2">
          <Button color="inherit" to="/" href="./" component={Link} className={classes.buttonName}>{process.env.REACT_APP_CLIENT_NAME}</Button>
        </Typography>
      </Toolbar>
    </AppBar>

  );
}
